import { render, staticRenderFns } from "./tabelWrap.vue?vue&type=template&id=17944686&scoped=true&"
import script from "./tabelWrap.vue?vue&type=script&lang=js&"
export * from "./tabelWrap.vue?vue&type=script&lang=js&"
import style0 from "./tabelWrap.vue?vue&type=style&index=0&id=17944686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17944686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17944686')) {
      api.createRecord('17944686', component.options)
    } else {
      api.reload('17944686', component.options)
    }
    module.hot.accept("./tabelWrap.vue?vue&type=template&id=17944686&scoped=true&", function () {
      api.rerender('17944686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabelWrap.vue"
export default component.exports